import { call, put, takeEvery } from 'redux-saga/effects';
import { DocumentsTypes } from './actionTypes';
import { getDocumentsSuccess, getDocumentsFail, getOneDocumentSuccess, getOneDocumentFail, getDocumentsSuccessInnoboDocs, getDocumentsFailInnoboDocs, uploadDocumentSuccessInnoboDocs, uploadDocumentFailInnoboDocs, getDocumentsInnoboDocs, deleteDocumentSuccessInnoboDocs, deleteDocumentFailInnoboDocs } from './actions';

import * as url from '../../helpers/url_helper';
import { ApolloClient, gql, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';


const extractFileNameAndExtension = (url:string) => {
    try {
      const fileNameWithExtension = url.split('/').pop();
      if (fileNameWithExtension && fileNameWithExtension.includes('.')) {
        // Separar nombre y extensión
        const fileParts = fileNameWithExtension.split('.');
        const extension = fileParts.pop(); 
        const name = fileParts.join('.');  
  
        return {
          name: name || '',  
          extension: extension || ''  
        };
      }
    } catch (error) {
      console.error('Error al extraer el nombre y extensión del archivo:', error);
    }
    return { name: '', extension: '' };
  };
  
  

export const fetchDocuments = async (data: any) => {
    const { GUID, type } = data;
    const path = url.API_URL;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    const query = `query { 
        GetDocumentNames(Document:{
            userId: ${user.id},
            GUID: "${GUID}",
            type: "${type}",
            }){
            DocumentsList {
                Identifier
                Name
                Extension
                ShipmentNumber
                ShipmentGUID
                LayoutType
            }
            }
        }
    `;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    const updatedDocs = response.data.GetDocumentNames.DocumentsList.map((doc: any) => ({
        ...doc,
        isSelected: false
    }));

    return updatedDocs;
};

function* getDocumentsSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchDocuments, data.payload);
        yield put(getDocumentsSuccess(response));
    } catch (error) {
        yield put(getDocumentsFail(error));
    }
}


export const fetchOneDocument = async (data: any) => {
    const { GUID, Identifier } = data;
    const path = url.API_URL;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    const query = `query {
        GetDocumentData(Document:{
            userId: ${user.id},
            GUID: "${GUID}",
            Identifier: ${Identifier}
            }){
            Document {
                Identifier      
                Data
            }
            }
    }
    `;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    return response.data.GetDocumentData.Document;
};

function* getOneDocumentSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchOneDocument, data.payload);
        yield put(getOneDocumentSuccess(response));
    } catch (error) {
        yield put(getOneDocumentFail(error));
    }
}


//------------------------------------------INNOBO DOCS---------------------------------------------------
function* uploadDocumentsInnoboDocs({payload}: any):any {
    const { file, GUID, type, Number } = payload;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    
    try {
        const client = new ApolloClient({
          link: createUploadLink({ uri: url.API_URL }),
          cache: new InMemoryCache(),
        });
        const query = gql`
          mutation LoadFileOperations(
            $file: Upload!
            $GUID: String!,
            $clientId: Int!,
            $Number: String!,
            $type: String! 
          ) {
            LoadFileOperations(fileOperation:{file: $file, GUID: $GUID, clientId: $clientId, Number: $Number, type: $type} ) {
              success
              message
            }
          }
        `;
        const mutationPromise = client.mutate({
          mutation: query,
          variables: { file, GUID: GUID ,clientId: user.EMPRESA_ID, Number: Number, type: type },
        });
        const response = yield call(() => mutationPromise);
        if (response?.data?.LoadFileOperations?.success) {
          yield put(uploadDocumentSuccessInnoboDocs(response.data.LoadFileOperations));
          yield put(getDocumentsInnoboDocs({ GUID, type, Number }));
        }else{
            yield put(uploadDocumentFailInnoboDocs(response?.data?.LoadFileOperations?.message));
        }
      } catch (error:any) {
        yield put(getDocumentsFailInnoboDocs(error.message));
      }
}


export const fetchDocumentsInnoboDocs = async (data: any) => {
    const { GUID, type } = data;
    const path = url.API_URL;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    const query = `query {
  GetInnoboDocuments(clientId:${user.EMPRESA_ID}, GUID:"${GUID}", operationType:"${type}"){
    clientId
    operationType
    urlLink
    GUID
    Number
  }
}
    `;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    const updatedDocs = response.data.GetInnoboDocuments.map((doc: any,index:any) => {
            const {name, extension} = extractFileNameAndExtension(doc.urlLink)
        return(
            {
                ...doc,
                isSelected: false,
                Identifier: `${doc.GUID}-${index}`,
                Name: name,
                Extension:extension,
            }
        )
    });


    return updatedDocs;

};

function* getDocumentSagaInnoboDocs(data: any) {
    try {
        const response: Promise<any> = yield call(fetchDocumentsInnoboDocs, data.payload);
        yield put(getDocumentsSuccessInnoboDocs(response));
    } catch (error) {
        yield put(getDocumentsFailInnoboDocs(error));
    }
}
//---------------------DELETE-----------------------------

export const deleteDocumentsInnoboDocs = async (data: any) => {
    const path = url.API_URL;
    const query = `mutation {
    DeleteFileOperations(Array: "${JSON.stringify(data).replace(/"/g, '\\"')}") {
            message
            success
        }
    }

    `;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());


    return response;

};

function* deleteDocumentSagaInnoboDocs(data: any) {
    try {
        const response: Promise<any> = yield call(deleteDocumentsInnoboDocs, data.payload);
        yield put(deleteDocumentSuccessInnoboDocs(response));
    } catch (error) {
        yield put(deleteDocumentFailInnoboDocs(error));
    }
}


function* DocumentsSaga() {
    yield takeEvery(DocumentsTypes.GET_DOCUMENTS, getDocumentsSaga);
    yield takeEvery(DocumentsTypes.GET_ONE_DOCUMENT, getOneDocumentSaga);

    yield takeEvery(DocumentsTypes.GET_DOCUMENTS_INNOBO_DOCS, getDocumentSagaInnoboDocs);
    yield takeEvery(DocumentsTypes.UPLOAD_DOCUMENT_INNOBO_DOCS, uploadDocumentsInnoboDocs);
    yield takeEvery(DocumentsTypes.DELETE_DOCUMENT_INNOBO_DOCS, deleteDocumentSagaInnoboDocs);
}

export default DocumentsSaga;
